import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Api } from "../../../utils/Variables";
import { ServiceUrl } from "../../../utils/ServiceUrl";
import LehangaMenu from "./LehangaMenu";

const LehangaMob = ({ location, history, menuClick }) => {
  const [sareeCategory, setSareeCategory] = useState(null);

  useEffect(() => {
    axios.get(`${Api.Url}${ServiceUrl.MENU.MEGA_MENU}`).then((res) => {
      if (res.data.status === "1") {
        const found = res.data.data.find(
          (item) => item.categoryname.toLowerCase() === "lehenga"
        );
        setSareeCategory(found);
      }
    });
  }, []);

  const handleLinkClick = (slug) => {
    menuClick(); // close modal
    const targetPath = `/category/${slug}`;
    if (location.pathname === targetPath) {
      history.replace("/");
      setTimeout(() => {
        history.push(targetPath);
      }, 0);
    } else {
      history.push(targetPath);
    }
  };

  const renderSubCategories = () => {
    if (!sareeCategory || !sareeCategory.subcategory) return null;

    return sareeCategory.subcategory.slice(0, 10).map((item, i) => (
      <li key={i}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick(item.slug);
          }}
        >
          {item.categoryname}
        </a>
      </li>
    ));
  };

  return <>{renderSubCategories()}</>;
};

export default withRouter(LehangaMob);
